import React, { Component } from 'react'
import Card from '@material-ui/core/Card'
import CardMedia from '@material-ui/core/CardMedia'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }
  componentDidCatch(_error, errorInfo) {
    this.setState({ error: true })
  }

  render() {
    if (this.state.error) {
      return (
        <Card>
          <CardMedia image="/img/vehicles/default.jpg" title="Contemplative Reptile" />
          <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
              We're Sorry
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              Something went wrong. Our team will be notified of the error.
            </Typography>
          </CardContent>
        </Card>
      )
    } else {
      // when there's not an error, render children untouched
      // eslint-disable-next-line react/prop-types
      return this.props.children
    }
  }
}

export default ErrorBoundary
